"use client";

import { useEffect } from "react";
import { logErrorToRollbar } from "@/services/rollbar";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    logErrorToRollbar(error, { digest: error.digest, context: 'segment-error' });
  }, [error]);

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center p-8 text-center">
      <h2 className="mb-4 text-2xl font-bold text-primary">Something went wrong!</h2>
      <p className="mb-8 text-slate-500 text-sm">We encountered an unexpected error while rendering this page.</p>
      <div className="flex gap-4">
        <button
          onClick={() => reset()}
          className="rounded-full bg-primary px-8 py-3 font-bold text-white transition hover:bg-sky-600 shadow-md cursor-pointer"
        >
          Try again
        </button>
        <button
          onClick={() => window.location.reload()}
          className="rounded-full border border-primary px-8 py-3 font-bold text-primary transition hover:bg-slate-50 cursor-pointer"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}
